import type { DeleteOrganisationWebhookMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { DeleteOrganisationWebhookDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useDeleteWebhook = createMutationHook({
  name: 'deleteWebhook',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.webhook.delete.mutationOptions({ onSuccess }),
  mapInput: (id: string) => ({ id }),
  invalidate: (trpc) => [trpc.frontend.webhook.list.queryKey()],
  mapResponse: (): DeleteOrganisationWebhookMutation => ({
    delete_organisation_webhook: {
      __typename: 'organisation_webhook_mutation_response',
      affected_rows: 1,
    },
  }),
  graphqlDocument: DeleteOrganisationWebhookDocument,
  graphqlVariables: (id: string) => ({ Id: id }),
  evictFields: ['organisation_webhook'],
});
